import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d68c9c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_2 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_3 = { class: "text-xs text-gray-500" }
const _hoisted_4 = { class: "text-lg md:text-lg" }
const _hoisted_5 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-1",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Vorhanden ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-4",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Details ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-1 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Biotypkartierung", -1))
const _hoisted_11 = { class: "col-span-1 text-xs text-gray-500" }
const _hoisted_12 = { class: "col-span-4 text-xs text-gray-500" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Einzelbäume", -1))
const _hoisted_14 = { class: "col-span-1 text-xs text-gray-500" }
const _hoisted_15 = { class: "col-span-4 text-xs text-gray-500" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Archäologisches Denkmal", -1))
const _hoisted_17 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "FFH Gebiet", -1))
const _hoisted_19 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Vogelschutzgebiet", -1))
const _hoisted_21 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Geotop", -1))
const _hoisted_23 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Geschütztes Offenlandbiotop (§)", -1))
const _hoisted_25 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Geschütztes Waldbiotop (§)", -1))
const _hoisted_27 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Naturdenkmal Flächenhaft", -1))
const _hoisted_29 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Naturdenkmal Einzelgebilde", -1))
const _hoisted_31 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Überschwemmungsgebiet HQ100", -1))
const _hoisted_33 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Überschwemmungsgebiet M1_M2", -1))
const _hoisted_35 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Gewässernetz", -1))
const _hoisted_37 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Wasserschutzgebiet", -1))
const _hoisted_39 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Heilquellenschutzgebiet", -1))
const _hoisted_41 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Landschaftsschutzgebiet", -1))
const _hoisted_43 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Waldschutzgebiet", -1))
const _hoisted_45 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Naturschutzgebiet", -1))
const _hoisted_47 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Biosphärengebiet", -1))
const _hoisted_49 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Bodendenkmale", -1))
const _hoisted_51 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Höhlenbäume", -1))
const _hoisted_53 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Haselmausnester", -1))
const _hoisted_55 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Reptilien", -1))
const _hoisted_57 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Weitere Informationen", -1))
const _hoisted_59 = { class: "col-span-6 text-xs text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tng_header = _resolveComponent("tng-header")!
  const _component_bewertung_chip_mehrfach = _resolveComponent("bewertung-chip-mehrfach")!
  const _component_be_footer = _resolveComponent("be-footer")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(), _createBlock(_component_pdf_a4_page, {
    "no-margin": "",
    "pdf-key": _ctx.lang
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_tng_header, {
            ba: _ctx.ba,
            immobilie: _ctx.immobilie,
            lang: _ctx.lang
          }, null, 8, ["ba", "immobilie", "lang"]),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.breadCrumb), 1),
          _createElementVNode("div", _hoisted_4, "Ökologie (" + _toDisplayString(_ctx.tab) + ")", 1),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'biotoptypkartierung')?.getSelectedAuswahlLabelsString()), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'biotoptypkartierung-details')?.['eingabeText']), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "biotoptypkartierung-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'einzelbaeume')?.getSelectedAuswahlLabelsString()), 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'einzelbaeume-details')?.['eingabeText']), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "einzelbaeume-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'archaeologisches-denkmal')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "archaeologisches-denkmal-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'ffh-gebiet')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "ffh-gebiet-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'vogelschutzgebiet')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "vogelschutzgebiet-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'geotop')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "geotop-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'geschuetztes-offenlandbiotop')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "geschuetztes-offenlandbiotop-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'geschuetztes-waldbiotop')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "geschuetztes-waldbiotop-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'naturdenkmal-flaechenhaft')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "naturdenkmal-flaechenhaft-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'naturdenkmal-einzelgebilde')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "naturdenkmal-einzelgebilde-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'ueberschwemmungsgebiet-hq100')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "ueberschwemmungsgebiet-hq100-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'ueberschwemmungsgebiet-m1-m2')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "ueberschwemmungsgebiet-m1-m2-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'gewaessernetz')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "gewaessernetz-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'wasserschutzgebiet')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "wasserschutzgebiet-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'heilquellenschutzgebiet')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "heilquellenschutzgebiet-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_42,
            _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'landschaftsschutzgebiet')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "landschaftsschutzgebiet-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'waldschutzgebiet')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "waldschutzgebiet-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_46,
            _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'naturschutzgebiet')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "naturschutzgebiet-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_48,
            _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'biosphaerengebiet')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "biosphaerengebiet-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_50,
            _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'bodendenkmale')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "bodendenkmale-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_52,
            _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'hoehlenbaeume')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "hoehlenbaeume-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_54,
            _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'haselmausnester')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "haselmausnester-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_56,
            _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'reptilien')?.getSelectedAuswahlLabelsString()), 1),
            _createVNode(_component_bewertung_chip_mehrfach, {
              fragesPath: "reptilien-bewertung",
              fragenblock: _ctx.oekologie,
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang,
              class: "justify-self-end"
            }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
            _hoisted_58,
            _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.oekologie.findFrageByRelativePath(_ctx.ba, 'oekologie-und-schutzgebiete-informationen')?.['eingabeText']), 1)
          ]),
          _createVNode(_component_be_footer, {
            ba: _ctx.ba,
            immobilie: _ctx.immobilie,
            lang: _ctx.lang
          }, null, 8, ["ba", "immobilie", "lang"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["pdf-key"]))
}